import { FormattedMessage, useIntl } from 'react-intl';
import Popover from 'client/components/aria/Popover/Popover';
import { mdiInformation } from '@mdi/js';
import Icon from '@mdi/react';
import defaultAriaProps from 'client/utils/constants/ariaPropTypes';
import { ContactDetails } from 'client/pages/MapPage/components/MapMenu/ContactDetails/ContactDetails';

import styles from './AssetOwner.module.scss';

const AssetOwner = ({ details, ...props }) => {
    const {
        label,
        contacts,
        copyrightText,
        disclaimerText,
        standardGuidanceText
    } = details;

    const testId = props['data-testid'] ?? 'assetOwners';

    const intl = useIntl();

    const displayPopoverContentIfExists = (descriptor, contents) => {
        if (!contents) {
            return null;
        }
        return (
            <>
                <span className="govuk-caption-m govuk-!-font-size-14">
                    {intl.formatMessage({ id: descriptor })}
                </span>
                <p className="govuk-body-s govuk-!-font-size-14">
                    {contents}
                </p>
            </>
        );
    };
    return (
        <div className={styles.container} data-testid={testId}>
            {label
                ? <h3 className="govuk-heading-m" data-testid={`${testId}.label`}>{label}</h3>
                : null
            }
            {contacts.business?.length ? <ContactDetails contacts={contacts.business} caption={intl.formatMessage({ id: 'assetOwners.businessContactDetails' })} data-testid={`${testId}.business`} /> : <></>}
            {contacts.emergency?.length ? <ContactDetails contacts={contacts.emergency} caption={intl.formatMessage({ id: 'assetOwners.emergencyContactDetails' })} data-testid={`${testId}.emergency`} /> : <></>}
            {disclaimerText || copyrightText || standardGuidanceText
                ? <Popover content={
                    <>
                        {displayPopoverContentIfExists('assetOwners.copyright', copyrightText)}
                        {displayPopoverContentIfExists('assetOwners.disclaimer', disclaimerText)}
                        {displayPopoverContentIfExists('assetOwners.standardGuidance', standardGuidanceText)}
                    </>
                }>
                    <span
                        className={styles.copyright}
                        data-testid={`${testId}.copyright`}
                    >
                        <Icon path={mdiInformation} size={1}/>
                        <FormattedMessage id="assetOwners.copyright"/>{' / '}
                        <FormattedMessage id="assetOwners.disclaimer"/>{' / '}
                        <FormattedMessage id="assetOwners.standardGuidance"/>
                    </span>
                </Popover>
                : null
            }
        </div>
    );
};

AssetOwner.propTypes = {
    ...defaultAriaProps
};

export default AssetOwner;
